import APIUtils from '@livongo/utilities/system/api';
import ProtoUtils from '../common/utilities/proto-utils';

const {
    getHeaders,
    Cgm: {
        DexcomAuthorizationClient,
        DexcomCreateAccessTokenRequest,
        DexcomGetAuthorizationStatusRequest,
        AbbottAuthorizationClient,
        AbbottCreateAccessTokenRequest,
        AbbottGetAuthorizationStatusRequest,
    },
} = ProtoUtils;

const SERVICE_URL =
    window?.process?.env?.SERVICE_URL ?? process.env.SERVICE_URL;

const CgmAPI = {
    /** Dexcom Authorization */
    createDexcomAccessToken(code) {
        const request = new DexcomCreateAccessTokenRequest();

        request.setName('user/liv/me/device/cgm/dexcom/authorization/token');
        request.setAuthorizationCode(code);

        return DexcomAuthorizationClient.createAccessToken(
            request,
            getHeaders()
        ).then(response => {
            return response?.toObject();
        });
    },
    /** Dexcom Authorization Status */
    getDexcomAuthorizationStatus() {
        const request = new DexcomGetAuthorizationStatusRequest();

        request.setName('user/liv/me/device/cgm/dexcom/authorization/status');

        return DexcomAuthorizationClient.getAuthorizationStatus(
            request,
            getHeaders()
        ).then(response => {
            return response?.toObject();
        });
    },
    /** Abbott Authorization */
    createAbbottAccessToken(code) {
        const request = new AbbottCreateAccessTokenRequest();

        request.setName('user/liv/me/device/cgm/authorization/token');
        request.setManufacturer('abbott');
        request.setAuthorizationCode(code);

        return AbbottAuthorizationClient.createAccessToken(
            request,
            getHeaders()
        );
    },
    /** Abbott Authorization Status */
    getAbbottAuthorizationStatus() {
        const request = new AbbottGetAuthorizationStatusRequest();

        request.setName('user/liv/me/device/cgm/authorization/status');

        return AbbottAuthorizationClient.getAuthorizationStatus(
            request,
            getHeaders()
        );
    },
    getCgmStatus() {
        // We can check for both Dexcom and Abbott status
        const request = new AbbottGetAuthorizationStatusRequest();

        request.setName('user/liv/me/device/cgm/authorization/status');

        return AbbottAuthorizationClient.getAuthorizationStatus(
            request,
            getHeaders()
        ).then(response => response?.toObject());
    },
    getTimezone() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
    /** CGM Summary */
    getSummary({startDate, endDate, locale}) {
        const url = `${SERVICE_URL}/service-device-cgm-v2/v2/users/me/device/cgm/summary?localTimezone=${CgmAPI.getTimezone()}&startDate=${startDate}&endDate=${endDate}`;

        return APIUtils.get(url, null, {
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': locale,
            },
        }).then(response => {
            const data = response?.data;

            return data;
        });
    },
    /** CGM Summary Daily */
    getSummaryDaily({date, locale}) {
        let url = `${SERVICE_URL}/service-device-cgm-v2/v2/users/me/device/cgm/summary/daily?localTimezone=${CgmAPI.getTimezone()}`;

        if (date) {
            url = url.concat(`&date=${date}`);
        }

        return APIUtils.get(url, null, {
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': locale,
            },
        }).then(response => {
            const data = response?.data;

            return data;
        });
    },

    /** CGM Summary Overview */
    getSummaryOverview() {
        const url = `${SERVICE_URL}/service-device-cgm-v2/v2/users/me/device/cgm/summary/overview?localTimezone=${CgmAPI.getTimezone()}`;

        return APIUtils.get(url).then(response => {
            const data = response?.data;

            return data;
        });
    },
};

export default CgmAPI;
